const accountTypes = {
    '0': 'Cash',
    '1': 'Margin',
    '2': 'Cash Upfront',
    '3': 'Collateralized'
};

const accountStatus = {
    '0': 'Inactive',
    '1': 'Active',
    '2': 'Suspended',
    '3': 'Expired',
    '4': 'Dormant',
    '5': 'Closed'
};

const currencyStatus = {
    '0': 'Inactive',
    '1': 'Active'
};

const contraTypes = {
    '0': 'Gain',
    '1': 'Loss'
};

const contractTypes = {
    '0': 'Purchase',
    '1': 'Sales'
};

const contractStatus = 
{
    "0": "Failed",
    "1": "In-progress",
    "2": "Completed",
    "3": "Pending"
};

const contractStettlementTypes = {
    "1": "Due For Force Selling",
    "2": "Due For Settlement",
    "3": "Remaining Purchase Contracts",
    "4": "Sales Proceed Due",
    "5": "Remaining Sales Contracts"
}

const tradeSides = {
    '0': 'Buy',
    '1': 'Sell',
};

const tradeSidesFull = {
    '0': 'Buy',
    '1': 'Sell',
    '2': 'Transfer In',
    '3': 'Transfer Out'
  
};


const stockTypes = {
    '0': 'None',
    '1': 'IPO',
    '2': 'Active',
    '3': 'Suspended',
    '4': 'Unavailable for trade',
    '5': 'Delisted',
    '6': 'Halted',
    '7': 'Restricted',
    '8': 'Opening Delay',
    '9': 'Closing Delay',
    '10': 'Unsubscribe'
};

const eStatementStatus = {
    '0': 'N',
    '1': 'Y'
};

const eContractStatus = {
    '0': 'N',
    '1': 'Y'
};

const IDSSStatus = {
    '0': 'N',
    '1': 'Y'
};

const currenciesList = [
    {
        c_id: 1,
        c_code: 'MYR',
        c_name: 'Ringgit Malaysia'
    }
];

const depositStatus = {
    '0': 'Inactive',
    '1': 'FPX',
    '2': 'Manual Transfer'
};

const manualTransferType = {
    '2': 'Cheque',
    '3': 'Cash'
};

const manualTransferType2 = {
    '1': 'FPX',
    '2': 'Cheque',
    '3': 'Cash'
};

const fundingType = {
    '1': 'Deposit',
    '2': 'Withdrawal',
    '3': 'Settlement'
};


const orderEntry:any = {
    "1": "Normal",
    "2": "Odd Lot",
    "3": "DBT",
    "7": "IDSS",
}

const categoriesText:any = {
    "1": "Normal",
    "2": "Odd Lot",
    "3": "DBT",
    "4": "Advance",
    "5": "Others"
}

const categoryTypeText:any = {
    "1": "Limit",
    "2": "Market",
    "3": "MarketToLimit",
    "4": "StopLimit",
    "5": "StopMarket",
    "6": "OMMT",
    "7": "IDSS",
    "8": "RSS",
    "9": "PDT",
    "10": "BuyingIn",
    "11": "Married",
    "12": "Crossing",
    "13": "MarketOnOpen",
    "14": "LimitOnOpen",
    "15": "MarketOnClose",
    "16": "LimitOnClose",
    "17": "OneCancelOther",
    "18": "BracketOrder",
    "19": "MarketIfTouched",
    "20": "LimitIfTouched",
    "21": "MarketPegged",
    "22": "PrimaryPegged",
    "23": "MarketSnap",
    "24": "PrimarySnap",
    "25": "PassiveRelative",
    "26": "TrailingStop",
    "27": "TrailingStopLimit",
    "28": "Iceberg"
}

const lastStatusText:any = {
    "1": "Expired",
    "2": "Removed",
    "3": "Modified in Queue",
    "4": "Pend. Approve",
    "5": "Rejected",
    "6": "Cancelled",
    "7": "Confirmed",
    "8": "Modified",
    "9": "Cancelled",
    "10": "All Matched",
    "11": "Partially Matched",
    "12": "Client Amend Cxl.",
    "13": "Client Amended",
    "14": "Expired",
    "15": "Exc. Rejected",
    "16": "Exc. Suspended",
    "17": "CP Rejected",
    "18": "Pend. CP Accept",
    "19": "Pend. Accept",
    "20": "Pend. CP Accept",
    "21": "Pend. Accept",
    "22": "Exc. Accepted",
    "23": "Exc. Rejected",
    "24": "Withdrawn",
    "25": "Order Received",
    "26": "Exception",
    "27": "Order forwarded",
    "28": "Order Received",
    "29": "Exception",
    "30": "Forwarding to Exchange",
    "31": "Preview",
    "32": "Order processing",
    "33": "Order in Process",
    "34": "Exception",
    "35": "Forwarded to Exchange",
    "37": "Submitted to Gateway",
    "44": "Order in Process",
    "46": "Order in Queue",
    "47": "Server Rejected",
    "48": "Failed",
    "49": "Pending",
    "50": "Invalid Trading PIN",
    "51": "Modify Rejected",
    "52": "Cancel Rejected",
    "53": "Exc. Eliminated",
    "54": "Cancel/Reduce By Exchange",
    "55": "Order Triggered",
    "56": "Modification Removed",
    "57": "Cancellation Removed",
    "58": "Cancellation in Queue",
    "59": "Server Error",
    "60": "Unknown Status",
    "61": "Pending Cancel",
    "62": "Pending Modified"
}
  

const accountSummaryType:any ={
    opening_trust:"Opening Trust Amount",
    opening_limit: "Opening Limit",
    intra_purchasesales: "Intraday Purchase-Sales",
    intra_fpxdeposit: "Intraday FPX Deposit",
    available_limit: "Available Limit",
    due_for_forceselling: "Due for Forced Selling",
    due_for_settlement: "Due for Settlement",
    remaining_purchase_contracts: "Remaining Purchase Contracts",
    sales_proceed_due: "Sales Proceeds Due",
    remaining_sales_contracts: "Remaining Sales Contracts",
    contra_gains: "Contra Gains",
    contra_losses: "Contra Losses",
    others: "Others",
    account_summary: "Account Summary"
}

const statementTypeMap:any ={
    1: {
        label: "Statement of Account",
        url: "/statement-of-account"
    },
    2: {
        label: "eContra",
        url: "/econtra"
    },
    3: {
        label: "eSetoff",
        url: "/esetoff"
    },
    4: {
        label: "ePayment Voucher",
        url: "/epayment-voucher"
    },
    5: {
        label: "eCredit/Debit Note",
        url: "/ecredit-debit-note"
    },
    6: {
        label: "eForeign Share Statement",
        url: "/eforeign-share-statement"
    },
    7: {
        label: "Payment Receipt",
        url: "/payment-receipt"
    },
    8: {
        label: "Cancellation of OR",
        url: "/cancellation-of-or"
    },
    9: {
        label: "Cancellation of PV",
        url: "/cancellation-of-pv"
    }
};

const financialTypes = {
    "0": "Credit Note",
    "1": "Debit Note",
    // "2": "Payment Voucher"
}

const mapChgPriceAction:any = {
    2:true,
    3:true,
    4:false, //"Bonus Issue, not allow change price",
    5:true, //"Right Issue, allow change price",
    6:true, //"Special Issue, allow change price",
    7:false, //"Shares Consolidate, not allow change price",
    8:false, //"Shares Split, not allow change price",
    9:true, //"IPO, not allow change price"
    10:false, //carry forward, not allow change price
}


//availabel status type
export default {
    accountTypes,
    accountStatus,
    currencyStatus,
    contraTypes,
    contractTypes,
    contractStatus,
    stockTypes,
    eStatementStatus,
    eContractStatus,
    IDSSStatus,
    currenciesList,
    depositStatus,
    manualTransferType,
    manualTransferType2,

    // trade related
    tradeSides,
    // funding related
    fundingType,
    orderEntry,
    categoriesText,
    categoryTypeText,
    lastStatusText,

    accountSummaryType,
    contractStettlementTypes,

    statementTypeMap,
    financialTypes,
    tradeSidesFull,

    mapChgPriceAction
};
